import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CalendarIcon} from 'shells/icon/svg/calendar-icon';
// @ts-expect-error - imported from .js/.jsx file
import {PhoneCallIcon} from 'shells/icon/svg/phone-call-icon';
import {TextRegularAiIcon} from 'shells/icon/svg/text-regular-ai-icon';
import {ConnectionInfoBody} from 'shells/status-button/connection-info-body';
import {ConnectionInfoDescription} from 'shells/status-button/connection-info-description';
import {ConnectionInfoTitle} from 'shells/status-button/connection-info-title';
import {Body} from 'shells/typography/body';

import type {GetSessionUser_loggedInUser_phoneIntegrations as PhoneIntegration} from 'nutshell-graphql-types';

import {appHistory} from '../../history';

import {getServiceNoun, getServiceTypeIconForStatusBar} from './helpers';

type Props = {
    phoneIntegrations: PhoneIntegration[];
    onClose: () => void;
};

export function PhoneIntegrationsStatusPopover(props: Props) {
    const {phoneIntegrations} = props;
    const hasEnabledIntegrations = phoneIntegrations.length > 0;

    if (!hasEnabledIntegrations) {
        return (
            <div className='flex align-center flex-dir-col pad-24 gap-16'>
                <img
                    src='/include/images/external-meetings/phone-integrations.svg'
                    alt='Calls empty state'
                    style={{width: '100%', maxWidth: 150}}
                />
                <Body size='normal' textAlign='center' color='dark'>
                    Call sync is not enabled. Connect a phone service to sync and summarize calls.
                </Body>
                <Button
                    variant='primary'
                    isFullWidth={true}
                    size='big'
                    onClick={() => {
                        props.onClose();
                        appHistory.push('/my-account/phone');
                    }}
                >
                    Get started
                </Button>
            </div>
        );
    }

    const servicesTitle = phoneIntegrations.length > 1 ? `Your connected services` : 'Connection';

    const descriptionItems = [
        {
            icon: <PhoneCallIcon wrapWithDiv={false} size={20} color={colors.grey} />,
            text: 'Recorded calls will sync into Nutshell automatically',
        },
        {
            icon: (
                // @ts-expect-error
                <TextRegularAiIcon wrapWithDiv={false} size={20} color={colors.aiPurplePrimary} />
            ),
            text: 'AI summaries and transcriptions are generated for each call',
        },
        {
            icon: <CalendarIcon wrapWithDiv={false} size={20} color={colors.grey} />,
            text: 'Calls appear as activities and can be logged to contacts or leads',
        },
    ];

    return (
        <ConnectionInfoBody title={servicesTitle}>
            <div className='flex flex-dir-col gap-8'>
                {phoneIntegrations.map((integration) => (
                    <ConnectionInfoTitle
                        key={integration.integrationType}
                        icon={getServiceTypeIconForStatusBar(integration.integrationType)}
                        primaryText={getServiceNoun(integration.integrationType)}
                        secondaryText={integration.externalUserIdentifier}
                        tertiaryText={integration.tertiaryInformation}
                    />
                ))}
            </div>
            <ConnectionInfoDescription items={descriptionItems} />
        </ConnectionInfoBody>
    );
}
